// The read-back panel under a picker: what the admin just chose, spelled out.
const AssignmentDetailCard = ({ rows }) => (
    <div className="tw:grid tw:grid-cols-1 tw:gap-2 tw:rounded-[5px] tw:border tw:border-[#E8E8E8] tw:bg-[#F9F9F9] tw:px-5 tw:py-4">
        {rows.map((row) => (
            <div key={row.label} className="tw:grid tw:grid-cols-1 tw:gap-2 tw:md:grid-cols-[260px_1fr]">
                <div className="tw:font-hanken-grotesk tw:text-[14px] tw:font-[400] tw:leading-[20px] tw:text-[#666666]">
                    {row.label}
                </div>
                <div className="tw:font-hanken-grotesk tw:text-[14px] tw:font-[400] tw:leading-[20px] tw:text-[#666666]">
                    {row.value || "-"}
                </div>
            </div>
        ))}
    </div>
);

export default AssignmentDetailCard;
